const normalizeFrenchAccents = (input: string): string => {
  return input
    .replace(/œ/g, 'oe')
    .replace(/Œ/g, 'OE')
    .replace(/æ/g, 'ae')
    .replace(/Æ/g, 'AE')
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');
};

export const normalizeFrenchSearch = (input: string): string => {
  return normalizeFrenchAccents(input)
    .toLocaleLowerCase('fr-FR')
    .trim()
    .replace(/\s+/g, ' ');
};
